/* Transparan header → kaydırınca dolu geçişi (yalnız ana sayfada) */
(function () {
  var body = document.body;
  if (!body.classList.contains('template-index')) return;
  var threshold = 60;
  function onScroll() {
    if (window.scrollY > threshold) body.classList.add('header-scrolled');
    else body.classList.remove('header-scrolled');
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // Geri sayım şeridi ve duyuru bandının yüksekliğini ölç → header tam altına otursun (üst üste binmesin)
  function setAnnH() {
    var ann = document.querySelector('.shopify-section-group-header-group .utility-bar');
    var cd = document.querySelector('.shopify-section-group-header-group .zr-cd');
    document.documentElement.style.setProperty('--zr-ann-h', (ann ? ann.offsetHeight : 0) + 'px');
    document.documentElement.style.setProperty('--zr-cd-h', (cd && cd.offsetParent ? cd.offsetHeight : 0) + 'px');
  }
  setAnnH();
  window.addEventListener('resize', setAnnH);
  window.addEventListener('load', setAnnH);
})();
